import { useEffect, useState } from "react";
import { Badge, Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { lddGlobalSessionInfo, NavObjectType } from "../navigationTypes";
import { DRImportTemplate } from "./BuilderConnectInfo/DRImportConfig";
import { validateRequiredFields } from "./BuilderConnectInfo/DRImportFuncs";
import { useAppSelector } from "../../redux/hooks";
import { RPWDataReader, getDataReader } from "../../livedataFuncs";
import styles from './BuilderBanner.module.css';
import { loginWithPassCode } from "../../dr/Components/drFuncs";
type BuilderInfoType = {
    projectName: string,
    fromLawyer: string,
    fromLawyerClerk: string,
    toLawyer: string,
    legalDesc: string,
    propertyAddr: string,
    fromLawyerClient: string,
    toLawyerClient: string,
    Builder: string,
}

type BuilderInfoPropsType = {
    sessionInfo: lddGlobalSessionInfo,
    msgID: string,
    showImport: boolean,
    drDataRoot?: any,
}

const BuilderBanner = (props: BuilderInfoPropsType) => {
    const [builderInfo, setBuilderInfo] = useState<BuilderInfoType>({Builder: "", projectName: "", fromLawyer: "", fromLawyerClerk: "", fromLawyerClient: "", toLawyer: "", toLawyerClient: "", propertyAddr: "", legalDesc: ""});
    const livedataRoot: any = useAppSelector((state) => state.currentNavigation.livedataRootContainer?.dataRoot);
    const processor: RPWDataReader = getDataReader(livedataRoot);
    const drProcessor: RPWDataReader = getDataReader(props.drDataRoot);
    const page: NavObjectType = useAppSelector((state) => state.currentNavigation.page);
    const [showOverwriteAlert, setShowOverwriteAlert] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (props.msgID > "") {
                let url;
                const passCode = processor.getVIPInfoPassCode();
                if (props.sessionInfo && passCode > "") {
                    await loginWithPassCode(passCode);
                }
                if (props.sessionInfo && (page.params?.PassCode !== "1" && !(passCode > ""))) {
                    url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${props.sessionInfo.firm.id}/${props.sessionInfo.user.account}/msginfo?SessionID=${props.sessionInfo.sid}&MsgID=${props.msgID}`;
                } else {
                    url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/passcode/msginfo?PassCode=1&MsgID=${props.msgID}`;
                }
                const res = await fetch(url);
                if (res.ok) {
                    const resJson = await res.json();
                    if (resJson.ok) {
                        const result: BuilderInfoType = resJson.result;
                        setBuilderInfo(result);
                    }
                }
            }
        };

        fetchData();
    }, [props.msgID]);

    const bannerHeader = () => {
        if (builderInfo && builderInfo.projectName) {
            if (builderInfo.Builder && builderInfo.Builder > "") {
                return `${builderInfo.projectName} from ${builderInfo.Builder}`;
            }
            return builderInfo.projectName;
        }
        return null
    }

    const onConfirmImportAll = () => {
        const secs = Object.entries(DRImportTemplate).filter(element => validateRequiredFields(element[1], processor, drProcessor));
        secs.forEach(sec => {
            if (sec[1].importAll) {
                if (sec[1].setter) {
                    sec[1].setter(drProcessor, processor);
                    return;
                }
                const fields = sec[1].fields.filter(field => validateRequiredFields(field, processor, drProcessor));
                fields.forEach(field => {
                    if (field.setter) {
                        field.setter(drProcessor, processor);
                    }
                })
            }
        });
        setShowOverwriteAlert(false);
    }

    const importButtonClass = () => {
        return props.showImport ? "" : " hide"
    }

    return <div className={styles.toolbar}>
        <Modal centered show={showOverwriteAlert} className="connect">
            <Modal.Header>
                <h2><i className="fak fa-connect-solid" style={{marginRight:'10px'}}></i>Import All?</h2>
            </Modal.Header>
            <Modal.Body>
                <p>Importing all information will replace information in your file. Are you sure you want to continue?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="text" onClick={() => setShowOverwriteAlert(false)}>Cancel</Button>                        
                <Button variant="primary" onClick={onConfirmImportAll}>Yes</Button>
            </Modal.Footer>
        </Modal>

        <span className="text-ellipsis">
            <i className="fak fa-connect-solid" />
            {bannerHeader()}
        </span>

        <span>
            {builderInfo.fromLawyer && 
                <OverlayTrigger placement="bottom-end" overlay={<Tooltip>Lawyer</Tooltip>}>
                    <Badge pill bg="info">{builderInfo.fromLawyer}</Badge>
                </OverlayTrigger>
            }

            {builderInfo.fromLawyerClerk && 
                <OverlayTrigger placement="bottom-end" overlay={<Tooltip>Clerk</Tooltip>}>
                    <Badge pill bg="info">{builderInfo.fromLawyerClerk}</Badge>
                </OverlayTrigger>
            }

            <Button
                variant="primary"
                onClick={() => setShowOverwriteAlert(true)} 
                className={importButtonClass()}
                style={{display: "none"}}>
                <i className="fa-solid fa-circle-arrow-right"/>
                Import All Information
            </Button>
        </span>
    </div>
}

export default BuilderBanner;